const betaLabels = ['(Beta)', '(Preview)']
export const getDisplayName = (modelName: string, modelId: string): string => {
  const name = modelName || modelId
  for (const suffix of betaLabels) {
    if (name.endsWith(suffix)) {
      return name.replace(suffix, '').trim()
    }
  }
  return name
}
